// react
import React, { Suspense } from "react";

// components
import Spinner from "../../../components/Spinner/ComponentLoader";

// load in the goal tree
const LazyViewWorkflows = React.lazy(() => import("./ViewWorkflows"));

const LazyViewWorkflowsLoader = () => (
	<Suspense fallback={<Spinner />}>
		<LazyViewWorkflows />
	</Suspense>
);

export default LazyViewWorkflowsLoader;
